export const personalInfo = {
  name: "Mohammad Tabish Mukaddam",
  title: "AI Internal Automation Manager",
  email: "leotb@duck.com",
  phone: "+91-8879300866",
  linkedin: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
  gravatar: "https://mohammadtabishmukaddam.link",
  telegram: "@LeonidasCeas",
  location: "India",
  dob: "18/10/2001"
};

export const skillCategories = {
  languages: [
    "Java", "Python", "JavaScript", "TypeScript", "C#", "HTML", "SQL", "ASP.NET"
  ],
  aiMachineLearning: [
    "Prompt Engineering", "RLHF", "RAG", "Fine-tuning"
  ],
  cloudDatabases: [
    "AWS", "Microsoft Azure", "Supabase (PostgreSQL)", "Oracle", "MongoDB", "Vector Databases"
  ],
  developmentTools: [
    "React", "Tailwind CSS", "GitHub", "VS Code", "Visual Studio", "Jupyter Notebook"
  ],
  automation: [
    "n8n", "Zoho Flows", "Lovable", "Claude Code"
  ],
  productivity: [
    "Asana", "Slack", "Notion", "Obsidian", "Zoho CRM", "Google Workspace", "MS Office Suite", "Twilio", "Vimeo ElevenLabs (Speech Synthesis/Voice Cloning/Agentic Development)"
  ],
  gameEngines: [
    "Unreal Engine 5"
  ]
};

export const projects = [
  {
    id: "orient_x",
    title: "Orient X (Tactical Operations & Organizational Command Console)",
    category: "web-app",
    description: "Architected and developed Orient X, a high-density \"anti-SaaS\" operations console utilizing React 18, TypeScript, Tailwind CSS, and Supabase. Designed a unified \"nuclear-submarine\" command interface-featuring an Obsidian theme and terminal-style microcopy-to consolidate strategic vision, workflow execution, and personnel governance into a single high-fidelity cockpit. Engineered a modular ecosystem unifying multi-horizon strategy, RACI-mapped task management with Gantt/Kanban views (Workflow X), SOP/KPI tracking (Systems X), and high-stakes threat triage (Issues X). Implemented automated organizational resonance and AWISOUKA/One-on-One debrief cycles synthesized via a \"Captain's Bridge\" executive dashboard for real-time personnel load and friction analytics. Secured the platform with a dual-role RBAC and RLS framework, integrating 14 event-driven notification types and a universal Cmd+K Nexus for seamless organizational telemetry.",
    techStack: ["React 18", "TypeScript", "Tailwind CSS", "Supabase", "Role-Based Access Control", "Row Level Security (RLS)"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: [
      "Designed a unified 'nuclear-submarine' command interface",
      "Engineered a modular ecosystem for strategy, task management, and tracking",
      "Implemented automated organizational resonance and executive dashboard",
      "Secured platform with dual-role RBAC and RLS framework",
      "Integrated 14 event-driven notification types and a universal Cmd+K Nexus"
    ]
  },
  {
    id: "orbit_os",
    title: "Orbit OS (Team Performance & Gamification Platform)",
    category: "web-app",
    description: "Architected and developed a comprehensive monthly performance measurement and gamification platform using React, TypeScript, Tailwind CSS, and Supabase. Engineered a proprietary 5-pillar scoring algorithm that dynamically blends 360-degree internal ratings with external productivity data integrated via Asana and custom tracker APIs. Designed the full-stack architecture to include interactive real-time dashboards, automated Slack leaderboard generation via Edge Functions, and complex role-based access control to drive organizational engagement and operational transparency.",
    techStack: ["React", "TypeScript", "Tailwind CSS", "Supabase", "Asana API", "Slack API", "Edge Functions", "Role-Based Access Control"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: [
      "Proprietary 5-pillar scoring algorithm",
      "Dynamic data blending with Asana and custom tracker APIs",
      "Interactive real-time dashboards",
      "Automated Slack leaderboard generation via Edge Functions",
      "Complex role-based access control"
    ]
  },
  {
    id: "safespace",
    title: "SafeSpace (Workplace Complaint Management System)",
    category: "web-app",
    description: "Architected a secure, legally compliant (POSH Act) workplace misconduct system featuring a 5-tier role-based access model enforced via strict Row-Level Security (RLS) policies. Engineered a tamper-resistant evidence pipeline utilizing SHA-256 hashing and malware scanning via asynchronous Edge Functions to ensure data integrity. Developed a dual-approval governance framework for high-stakes workflow transitions, including identity unmasking and case archival, while implementing automated conflict-of-interest detection to ensure unbiased inquiry processes.",
    techStack: ["Supabase", "PostgreSQL", "Row Level Security (RLS)", "SHA-256 Hashing", "Edge Functions", "POSH Act Compliance", "Role-Based Access Control"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["5-tier role-based access model with strict RLS", "Tamper-resistant evidence pipeline with SHA-256 hashing", "Dual-approval governance framework", "Automated conflict-of-interest detection"]
  },
  {
    id: "anonymous_suggestion_box",
    title: "Anonymous Suggestion Box",
    category: "web-app",
    description: "Architected a zero-knowledge anonymous feedback system utilizing SHA-256 hashing and strict 3-tier RBAC. Engineered real-time features including live upvoting logic, automated Slack notifications via Edge Functions, and interactive admin dashboards for data analytics and CSV exports.",
    techStack: ["SHA-256 Hashing", "3-tier RBAC", "Edge Functions", "Slack Notifications", "Real-time Upvoting", "Admin Dashboards", "CSV Exports"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Zero-knowledge anonymous feedback system", "Strict 3-tier RBAC implementation", "Real-time upvoting and Slack notifications", "Interactive admin dashboards with CSV export"]
  },
  {
    id: "fps_shooter_ue5",
    title: "First Person FPS Shooter – Unreal Engine 5",
    category: "game-development",
    description: "A sci-fi target shooter featuring futuristic weapons and environments. Developed using Unreal Engine 5 with advanced lighting, particle effects, and immersive gameplay mechanics for an engaging first-person shooting experience.",
    techStack: ["Unreal Engine 5", "Advanced Lighting", "Particle Effects", "Gameplay Mechanics"],
    mediaUrl: "https://drive.google.com/file/d/1mTA8zrTk6ZNMJO9ahm2i-_glo9MWnS97/view",
    mediaType: "video",
    achievements: ["Futuristic weapon systems", "Advanced lighting and particle effects", "Immersive gameplay mechanics"]
  },
  {
    id: "third_person_shooter",
    title: "Third Person Shooter – Unreal Engine 5",
    category: "game-development",
    description: "A third-person shooter game where two teams compete in a team deathmatch. The game map was built using Genesys's proprietary drone data, simulating a real-world environment for tactical gameplay.",
    techStack: ["Unreal Engine 5", "Genesys Drone Data", "Team Deathmatch", "Real-world Environment Simulation"],
    mediaUrl: "https://drive.google.com/file/d/1UDW-srfI2uKlOsh970QnqhtQXx3x8U-F/view",
    mediaType: "video",
    achievements: ["Two-team competitive gameplay", "Real-world map using proprietary drone data", "Tactical team deathmatch mechanics"]
  },
  {
    id: "vehicle_simulation",
    title: "Vehicle Simulation for Complex Intersections – Unreal Engine 5",
    category: "game-development",
    description: "A realistic vehicle simulation using HD Map data to visualize maneuvering through complex road intersections. Aimed to support real-world traffic preview and autonomous vehicle validation.",
    techStack: ["Unreal Engine 5", "HD Map Data", "Vehicle Maneuvering", "Autonomous Vehicle Validation"],
    mediaUrl: "https://drive.google.com/file/d/1tyydnVegnXwOkUOScfdrfdBRr9n8tBFT/view",
    mediaType: "video",
    achievements: ["HD Map data integration", "Complex intersection navigation", "Real-world traffic preview capabilities"]
  },
  {
    id: "swarm_simulation",
    title: "Swarm-Based Game Simulation – Unreal Engine 5",
    category: "game-development",
    description: "Developed a simulation where AI agents mimic swarm behavior in a game environment. Focused on pathfinding, collision avoidance, and dynamic decision-making.",
    techStack: ["Unreal Engine 5", "AI Agents", "Pathfinding", "Collision Avoidance", "Dynamic Decision-making"],
    mediaUrl: "https://drive.google.com/file/d/1tyydnVegnXwOkUOScfdrfdBRr9n8tBFT/view",
    mediaType: "video",
    achievements: ["AI agent swarm behavior", "Advanced pathfinding algorithms", "Collision avoidance systems"]
  },
  {
    id: "ai_sales_agent_n8n",
    title: "AI Sales Agent (using n8n)",
    category: "ai-automation",
    description: "Designed and oversaw the development of an end-to-end, WhatsApp-first AI sales agent on n8n that ingests CTWA chats and/or Meta Lead Ads with UTM attribution into Zoho, hydrates/normalizes data, triggers an AI phone call (IVR/BANT, confusion detection, redial), then post-call qualifies and tier-routes leads, orchestrates dynamic, labelled material sharing with analytics write-back, runs bounded nudges and reminder cadences, and manages the full quote to invoice to payment flow-while logging interactions to CRM and hardening reliability with idempotency/dedupe, retries/backoff, monitoring/alerts, and an auditable human-override trail.",
    techStack: ["n8n", "WhatsApp API", "Meta Lead Ads", "Zoho CRM", "AI Phone Calls", "IVR/BANT"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["End-to-end sales automation", "AI phone call qualification with confusion detection", "Full quote to invoice to payment flow", "CRM integration with reliability features"]
  },
  {
    id: "transcript_automation_n8n",
    title: "Transcript Automation (using n8n)",
    category: "ai-automation",
    description: "An AI automation built in n8n that transcribes, summarizes and moves (after successful transcription + summarisation) audio/video files from Google Drive. Utilizes GPT-4o for high-accuracy transcription and summarization, automatically delivering results to Slack to enhance workflow efficiency.",
    techStack: ["n8n", "Google Drive API", "Slack API", "GPT-4o"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["High-accuracy transcription with GPT-4o", "Automated file movement after processing", "Slack integration for workflow efficiency"]
  },
  {
    id: "asana_slack_project_automation",
    title: "Project Management Automation (Asana & Slack)",
    category: "ai-automation",
    description: "Architected a comprehensive Asana automation framework using Rules to streamline the entire task lifecycle. These automations triggered dynamic Slack notifications based not only on time (due date and overdue reminders) but also on key workflow events, including tasks moving between project stages, changes in assignee, priority escalations, and task completion status.",
    techStack: ["Asana Rules", "Slack API", "Workflow Automation", "Task Lifecycle Management"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Comprehensive task lifecycle automation", "Dynamic notifications for workflow events", "Integration of time-based and event-based triggers"]
  },
  {
    id: "company_seedfund_dashboard",
    title: "Company Seedfund Dashboard",
    category: "ai-automation",
    description: "A comprehensive business intelligence suite consolidating ten dashboards to monitor company performance across revenue, employee costs, and financials (to name a few). Developed with robust user authentication and automated data fetching to provide a secure, 360-degree view of the business.",
    techStack: ["Business Intelligence", "User Authentication", "Automated Data Fetching", "Financial Analytics"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["10 consolidated dashboards for comprehensive monitoring", "Robust user authentication system", "360-degree business view with automated refresh"]
  },
  {
    id: "employee_cost_dashboard",
    title: "Employee Cost Dashboard",
    category: "ai-automation",
    description: "A secure dashboard for visualizing employee costs by designation, providing key insights for HR and financial decision-making. Built with secure login validation, on-demand data refresh, and export capabilities to streamline the analysis of workforce expenditure.",
    techStack: ["Secure Login Validation", "Data Visualization", "Export Capabilities", "HR Analytics"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Secure login validation system", "Designation-wise cost insights", "On-demand refresh and export capabilities"]
  },
  {
    id: "tool_cost_utilization_dashboard",
    title: "Tool Cost and Utilization Dashboard",
    category: "ai-automation",
    description: "A business intelligence dashboard for monitoring and optimizing software costs by pulling real-time data from Google Sheets. Features an integrated Slack bot for automated weekly alerts on expiries and high-cost tools, enabling proactive financial management.",
    techStack: ["Google Sheets API", "Slack Bot", "Real-time Data Processing", "Automated Alerts"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Real-time software cost monitoring", "Automated weekly alerts for expiries and high costs", "Proactive financial management capabilities"]
  },
  {
    id: "openbot_ai_chat",
    title: "OpenBot – Advanced AI Chat",
    category: "ai-automation",
    description: "Designed and Developed: OpenBot, an advanced AI chat application featuring a futuristic cyberpunk interface and the ability to seamlessly switch between over 50 large language models (LLMs) through the OpenRouter API. The application supports real-time conversation streaming, an experimental sync mode to preserve context across model switches, local data encryption, and a responsive design.",
    techStack: ["OpenRouter API", "Large Language Models", "Real-time Streaming", "Data Encryption", "Cyberpunk UI", "Responsive Design"],
    mediaUrl: "https://theopenbot.netlify.app/",
    mediaType: "link",
    achievements: ["Futuristic cyberpunk interface", "Switch between over 50 LLMs", "Real-time conversation streaming", "Experimental sync mode for context preservation", "Local data encryption", "Responsive design"]
  },
  {
    id: "multi_ingestion_system",
    title: "Multi-Ingestion System",
    category: "ai-automation",
    description: "Architected and deployed a fully automated, event-driven RAG (Retrieval-Augmented Generation) pipeline using n8n. This system transforms unstructured data (text, pdf, audio, YouTube links) from a cloud-based file repository into a dynamic and intelligent conversational knowledge base which you can chat with using a robust interface, with its output seamlessly getting appended into Notion using a keyword-based system.",
    techStack: ["n8n", "RAG", "Event-driven Architecture", "Knowledge Base", "Automation", "Notion", "Keyword-based System", "Google Drive API", "React"],
    mediaUrl: "https://drive.google.com/file/d/1xNFqGmYLbXj94qNuj_qxB0nwvoyB8LmI/view?usp=sharing",
    mediaType: "link",
    achievements: ["Fully automated pipeline", "Event-driven architecture", "Cloud-based data transformation", "Conversational knowledge base creation"]
  },
  {
    id: "employee_time_tracking",
    title: "Employee Time Tracking System",
    category: "web-app",
    description: "Architected a full-stack time tracking system, featuring strict RLS policies for role-based access (Employee, Admin, Super Admin). Engineered the core tracking logic to rely on a server-side PostgreSQL function that calculates elapsed session time, ensuring accurate duration logging and preventing client-server clock skew. This system's daily performance analysis (on-time, overtime, undertime) was then fully automated using a database trigger that populated a daily analytics table in real-time as new work sessions were logged.",
    techStack: ["PostgreSQL", "Row Level Security (RLS)", "Role-Based Access Control", "Real-time Analytics", "Database Triggers"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Implemented strict RLS policies for role-based access", "Server-side time calculation to prevent clock skew", "Automated real-time performance analytics"]
  },
  {
    id: "culture_analytics_dashboard",
    title: "Organizational Culture Analytics Dashboard",
    category: "ai-automation",
    description: "Developed a real-time employee engagement system, featuring granular RBAC permissions and RLS-secured data access. Integrated Supabase Realtime to power live dashboards and engineered a unique 'Snapshot' feature that stores complex analytics states as JSONB for historical tracking. Implemented advanced data visualizations (Radar/Bar charts) to track culture alignment scores.",
    techStack: ["Supabase", "PostgreSQL", "JSONB", "Real-time Updates", "Data Visualization", "RBAC"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Real-time dashboard with Supabase Realtime", "Historical analytics with JSONB snapshots", "Advanced data visualizations for culture metrics"]
  },
  {
    id: "video_production_management",
    title: "Video Production Management System",
    category: "web-app",
    description: "Architected a secure, role-based project management platform, implementing strict Row Level Security (RLS) to enforce granular access control across Editor, Supervisor, and Admin roles. Engineered a custom 'Master Hold' system that dynamically pauses project timers and recalculates performance metrics (SLA) by excluding non-productive durations, while integrating OpenAI via Edge Functions to auto-generate issue resolution summaries and route real-time, category-specific notifications to Slack.",
    techStack: ["Row Level Security (RLS)", "OpenAI API", "Edge Functions", "Slack Integration", "Role-Based Access Control"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Custom Master Hold system for accurate time tracking", "AI-powered issue resolution summaries", "Role-based access control and real-time notifications"]
  },
  {
    id: "employee_leave_dashboard",
    title: "Employee Leave Management Dashboard",
    category: "web-app",
    description: "Developed an employee leave management system that streamlines the leave request and approval process for organizations. The platform enables employees to submit leave requests, view their leave history, and receive real-time updates. Administrators can manage leave requests, access comprehensive analytics, and monitor organizational leave trends through interactive dashboards. The solution incorporates automated notifications, robust role-based access control, and responsive user interfaces, enhancing both productivity and the overall employee experience.",
    techStack: ["React", "Supabase", "Role-based Access Control", "Real-time Notifications", "Slack"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["Streamlined leave request and approval process", "Real-time notifications and updates", "Interactive analytics dashboards", "Role-based access control system", "Enhanced employee productivity and experience"]
  },
  {
    id: "generative_ai_video_pipeline",
    title: "End-to-End Generative AI Video Pipeline (n8n & Vertex AI)",
    category: "ai-automation",
    description: "Architected an event-driven n8n automation and a custom front-facing UI to manage the full creative lifecycle. The system begins with a multi-modal RAG chatbot that ingests knowledge from PDFs, audio, and YouTube transcripts. An AI agent then generates video prompts from chat requests, which are routed to a Google Sheets-based human-in-the-loop (HITL) approval queue. Upon approval, an asynchronous job handler automatically triggers Google's Veo 3.0 (Vertex AI) API, polls for completion, delivers the final video asset to Dropbox, and updates the tracking sheet.",
    techStack: ["n8n", "Vertex AI", "Google Veo 3.0", "RAG", "Multi-modal Chatbot", "Google Sheets", "Dropbox API", "Event-driven Architecture", "AI Agent", "Human-in-the-loop"],
    mediaUrl: "https://linkedin.com/in/mohammad-tabish-mukaddam-ab1428178",
    mediaType: "link",
    achievements: ["End-to-end creative lifecycle automation", "Multi-modal RAG chatbot integration", "Human-in-the-loop approval workflow", "Google Veo 3.0 API integration", "Automated video generation and delivery", "Event-driven architecture implementation"]
  }
];

export const workExperience = [
  {
    id: "digital_sukoon",
    company: "Digital Sukoon Pvt. Ltd.",
    position: "AI Internal Automation Manager",
    duration: "May 2026 – Present",
    description: [
      "Engineering the company's AI-powered operational infrastructure and technical ecosystem to drive business optimization.",
      "Developing event-driven automations for content, media, reporting, and publishing workflows using AI and automation platforms.",
      "Managing technical systems including servers, NAS, and cloud platforms while monitoring system performance and operational efficiency.",
      "Architecting API integrations and internal operational tools to consolidate cross-departmental functions and provide troubleshooting support.",
      "Researching and implementing emerging AI technologies to build robust, scalable automation systems across all company operations."
    ],
    achievements: [
      "Engineered AI-powered operational infrastructure",
      "Developed event-driven automations for content and media",
      "Architected API integrations and internal operational tools",
      "Managed and monitored technical systems and cloud platforms"
    ],
    technologies: ["AI", "Automation Platforms", "Servers", "NAS", "Cloud Platforms", "API Integrations"]
  },
  {
    id: "rudyculous",
    company: "Rudyculous Entertainment",
    position: "Operations and Technology Assistant (OTA)",
    duration: "August 2025 – April 2026",
    description: [
      "Drive operational efficiency by directing team workflows, managing tech stack, engineering automations, dashboards for data-driven insights",
      "Managing key business functions including pricing strategy and talent acquisition"
    ],
    achievements: [
      "Improved operational efficiency through automation",
      "Implemented data-driven decision making processes",
      "Streamlined team workflows and tech stack management"
    ],
    technologies: ["Automation Tools", "Data Analytics", "Project Management", "Team Leadership"]
  },
  {
    id: "genesys",
    company: "Genesys International Corporation Ltd",
    position: "Intern",
    duration: "January 2025 – February 2025",
    description: [
      "Transformed HD map content into a UE5-compatible format to simulate vehicle maneuvering through complex intersections",
      "Integrated proprietary 3D reality models to build immersive environments supporting Urban Planning, Utility, and Disaster Management use cases"
    ],
    achievements: [
      "Successfully converted HD map data for UE5 compatibility",
      "Integrated 3D reality models for urban planning applications",
      "Contributed to disaster management simulation systems"
    ],
    technologies: ["Unreal Engine 5", "HD Mapping", "3D Modeling", "Urban Planning", "GIS"]
  },
  {
    id: "genesys-traffic",
    company: "Genesys International Corporation Ltd",
    position: "Intern",
    duration: "May 2024 – June 2024",
    description: [
      "Created a traffic simulation Proof-of-Concept using Unreal Engine 5 to model urban mobility",
      "Built dynamic vehicle behavior and realistic traffic scenarios for visualization purposes"
    ],
    achievements: [
      "Developed traffic simulation PoC for urban mobility",
      "Implemented dynamic vehicle behavior systems",
      "Created realistic traffic scenarios for visualization"
    ],
    technologies: ["Unreal Engine 5", "Traffic Simulation", "AI Behavior", "Urban Mobility", "Visualization"]
  }
];

export const education = [
  {
    id: "msc-cs",
    degree: "MSc Computer Science",
    institution: "SK Somaiya Vidyavihar University",
    duration: "2023-2025",
    cgpa: "9.78",
    description: [
      "Specialized in advanced computer science concepts",
      "Completed research on game design strategies and ethical monetization models",
      "Presented research at ICETDT 2025 conference"
    ]
  },
  {
    id: "bsc-cs",
    degree: "BSc Computer Science (Hons)",
    institution: "SK Somaiya Vidyavihar University",
    duration: "2020-2023",
    cgpa: "9.38",
    description: [
      "Foundation in computer science principles",
      "Developed strong programming and problem-solving skills",
      "Completed various technical projects"
    ]
  },
  {
    id: "class-xii",
    degree: "Class XII",
    institution: "Mithibai College of Arts, Chauhan Institute of Science & Amrutben Jivanlal College of Commerce and Economics",
    duration: "2018-2020",
    cgpa: "75.85%",
    description: [
      "Science stream with focus on mathematics and computer science",
      "Developed analytical thinking and problem-solving abilities"
    ]
  },
  {
    id: "class-x",
    degree: "Class X",
    institution: "Prime Academy School",
    duration: "2016-2018",
    cgpa: "82.33%",
    description: [
      "Strong foundation in core subjects",
      "Developed study habits and academic discipline"
    ]
  }
];

export const certifications = [
  {
    id: "process-data-clean",
    title: "Process Data from Dirty to Clean (Google)",
    issuer: "Google",
    date: "July 2025",
    description: "Gained skills in data cleaning and processing using tools like SQL and spreadsheet software. Learned to apply data validation and transformation techniques to ensure data integrity and quality. Acquired an understanding of methods for handling inconsistencies and preparing reliable datasets for analysis."
  },
  {
    id: "prepare-data-exploration",
    title: "Prepare Data for Exploration (Google)",
    issuer: "Google",
    date: "July 2025",
    description: "Acquired comprehensive skills in data management and processing, with a strong focus on preparing diverse datasets for in-depth exploration and analysis. Learned to effectively work with various database systems, apply fundamental data analysis techniques, and consistently adhere to best practices in data ethics to ensure both data integrity and responsible handling throughout the data pipeline."
  },
  {
    id: "ask-questions-data",
    title: "Ask Questions to Make Data-Driven Decisions (Google)",
    issuer: "Google",
    date: "July 2025",
    description: "Developed skills in formulating precise and impactful questions essential for guiding effective data analysis. Utilized spreadsheet software for data manipulation, cleaning, and organization. Applied systematic problem-solving techniques to extract meaningful and actionable insights from complex datasets, enabling strategic, data-driven decision-making and contributing to organizational objectives."
  },
  {
    id: "foundations-data",
    title: "Foundations: Data, Data, Everywhere (Google)",
    issuer: "Google",
    date: "July 2025",
    description: "Gained foundational knowledge in data analysis and visualization, exploring the data ecosystem, data-driven decision-making, and the lifecycle of data. Developed skills in identifying data types, understanding data formats, and preparing data for effective analysis and presentation."
  },
  {
    id: "human-skills-ai",
    title: "Human Skills in the Age of AI (Microsoft & LinkedIn)",
    issuer: "Microsoft & LinkedIn",
    date: "July 2025",
    description: "Explored critical human competencies for the AI era, including adaptability, decision-making, communication, social intelligence, and creative thinking. Learned to integrate generative AI into collaborative problem-solving, enhance team dynamics, and navigate workplace transformation through future-ready interpersonal skills."
  },
  {
    id: "notion-beginners",
    title: "Notion for Beginners: Create a Project Plan (Coursera)",
    issuer: "Coursera",
    date: "July 2025",
    description: "Learned workspace and teamspace setup, project scope documentation, relational databases, Kanban and timeline views, Gantt chart generation, resource sharing, and internal Wiki creation using Notion for collaborative project management."
  },
  {
    id: "generative-ai-llm",
    title: "Generative AI with Large Language Models (Coursera)",
    issuer: "Coursera",
    date: "June 2025",
    description: "Learned LLM project lifecycle, prompt engineering, fine-tuning, RLHF, model optimization (distillation, quantization, pruning), RAG, ReAct, PAL frameworks, and LangChain for real-world AI application development."
  }
];

export const researchPublications = [
  {
    id: "icetdt-2025",
    title: "ICETDT 2025 - Research Paper Presentation & Publication",
    subtitle: "Optimizing Player Engagement and Retention: A Comprehensive Analysis of Game Design Strategies and Ethical Monetization Models",
    publishedIn: "Official proceedings of ICETDT-2025 (ISBN: 978-81-970361-0-1)",
    summary: "Explored factors driving long-term player engagement through ethical monetization and game design strategies.",
    highlights: "Presented a comprehensive analysis of player psychology and sustainable design models in gaming, in addition to conducting a survey for the same."
  }
];
